module.exports = __webpack_public_path__ + "static/img-home-whatson-2-d829413c68eec747178d227ebd5e04b8.png";